import { RegionEnum } from '__generated__/types';
import { CURRENT_REGION } from 'config/regions/config';
import { Regions } from 'config/regions/types';

/**
 * Converts number (ERP object key) to GSH code (GSH object key)
 * PR-55350 -> PR-EU55350
 * D-55350 -> D-EU55350
 */
export const convertNumberToGshCode = (number: string, region: RegionEnum | Regions = CURRENT_REGION) => {
  return number.replace('-', `-${region}`);
};
